export default (params) => ({
  trigger: {
    name: 'product_trade_in_overlay.pick_answer_in_questionnaire',
    params: params,
  },
  config: {
    schema: {
      question: {
        type: 'string',
      },
      answer: {
        type: 'string',
      },
    },
    event: {
      name: 'select_answer',
      params: {
        sub_feature: null,
      },
    },
  },
});
